var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.827.743h28.5a4.75 4.75 0 0 1 4.75 4.75v14.25a4.75 4.75 0 0 1-4.75 4.75h-28.5a4.75 4.75 0 0 1-4.75-4.75V5.493a4.75 4.75 0 0 1 4.75-4.75Zm32.25 4.75a3.75 3.75 0 0 0-3.75-3.75h-28.5a3.75 3.75 0 0 0-3.75 3.75v14.25a3.75 3.75 0 0 0 3.75 3.75h28.5a3.75 3.75 0 0 0 3.75-3.75V5.493Z",
    fill: "#004152"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.187 8.693a4.75 4.75 0 1 0 0 7.84 5.91 5.91 0 0 1 0-7.84Z",
    fill: "#EB001B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.637,
    cy: 12.613,
    r: 4.75,
    fill: "#F79E1B"
  })));
};
export default SvgMastercard;